/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Hook_Primary_ActionInputs */

const en_onboarding_v1_hook_primary_action = /** @type {(inputs: Onboarding_V1_Hook_Primary_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show me`)
};

const de_onboarding_v1_hook_primary_action = /** @type {(inputs: Onboarding_V1_Hook_Primary_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeig es mir`)
};

const pt_br2_onboarding_v1_hook_primary_action = /** @type {(inputs: Onboarding_V1_Hook_Primary_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero ver`)
};

const tr_onboarding_v1_hook_primary_action = /** @type {(inputs: Onboarding_V1_Hook_Primary_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Göster`)
};

const zh_cn2_onboarding_v1_hook_primary_action = /** @type {(inputs: Onboarding_V1_Hook_Primary_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带我看看`)
};

const zh_hk2_onboarding_v1_hook_primary_action = /** @type {(inputs: Onboarding_V1_Hook_Primary_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帶我看看`)
};

const ko_kr2_onboarding_v1_hook_primary_action = /** @type {(inputs: Onboarding_V1_Hook_Primary_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인하기`)
};

const ru_ru2_onboarding_v1_hook_primary_action = /** @type {(inputs: Onboarding_V1_Hook_Primary_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покажите мне`)
};

const es_419_onboarding_v1_hook_primary_action = /** @type {(inputs: Onboarding_V1_Hook_Primary_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muéstrame`)
};

/**
* | output |
* | --- |
* | "Show me" |
*
* @param {Onboarding_V1_Hook_Primary_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_hook_primary_action = /** @type {((inputs?: Onboarding_V1_Hook_Primary_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Hook_Primary_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_hook_primary_action(inputs)
	if (locale === "de") return de_onboarding_v1_hook_primary_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_hook_primary_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_hook_primary_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_hook_primary_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_hook_primary_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_hook_primary_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_hook_primary_action(inputs)
	return es_419_onboarding_v1_hook_primary_action(inputs)
});